import React, { Component } from "react"
import { FormControl } from "react-bootstrap"
import Select from "react-select"
import DatePicker from "../../../../../../../components/common/DatePicker"
import snackBar from "../../../../../../../utilities/snackBar/SnackBar"
import EditIncidentTypes from "../../../../../Types/EditIncidentTypes"
import WorkCompReferenceTypes from "../../../../../Types/WorkCompReferenceTypes"
import incidentParams from "../../IncidentParams"
import moment from "moment"

interface Props {
    incident: EditIncidentTypes
    incidentReference: WorkCompReferenceTypes
    appendParams: Function
    setEventType: Function
    handleChange: Function | any
    timeFormat: string
    readOnly: boolean
}

class BasicIncident extends Component<Props, {}> {

    maxDaysOff = 548

    handleNumberSpinner = (direction: string, paramName: string) => {
        //fix this mess
        if (!this.props.readOnly) {
            if (direction === "-") {
                if (!incidentParams[paramName] || parseInt(incidentParams[paramName]) === 0) {
                    this.props.appendParams([{ [paramName]: null }])
                } else {
                    this.props.appendParams([{ [paramName]: parseInt(incidentParams[paramName]) - 1 }])
                }
            } else if (direction === "+") {
                if (!incidentParams[paramName]) {
                    this.props.appendParams([{ [paramName]: 1 }])
                } else {
                    if (parseInt(incidentParams[paramName]) >= this.maxDaysOff) {
                        this.props.appendParams([{ [paramName]: this.maxDaysOff }])
                        snackBar({ text: `Maximum days off are ${this.maxDaysOff}`, type: "error", timeout: 4000 })
                    } else {
                        this.props.appendParams([{ [paramName]: parseInt(incidentParams[paramName]) + 1 }])
                    }
                }
            }
        }
    }

    render() {

        const incident = this.props.incident
        const props = this.props
        let pillType = "Raised"
        const readOnly = props.readOnly

        return (
            <div className={`BasicIncident${pillType}`} id="basic-incident">
                {/* <div className="EditIncidentSetRaised" onClick={() => this.props.setRaised()}>
                    {props.raised && <span className="material-icons">border_clear</span>}
                    {!props.raised && <span className="material-icons">border_outer</span>}
                </div> */}
                <div className={`HRPill HRPill${pillType}`} id="IncidentTypeId">
                    <div className="HRPillRadiosBtnsWrapper">
                        <p className="HRPillTitle">Incident Type:</p>
                        {this.props.incidentReference.incidentTypes.map((incidentType) =>
                            <div className="HRPillRadioBtn" key={`incident-type-btn-${incidentType.id}`} onClick={() => this.props.appendParams([{ IncidentTypeId: incidentType.id }])}>
                                <p>{incidentType.text}</p>
                                {incident.IncidentTypeId === incidentType.id && <div className="HRPillRadioBtnCustomRadioChecked"></div>}
                                {incident.IncidentTypeId !== incidentType.id && <div className="HRPillRadioBtnCustomRadioUnchecked"></div>}
                            </div>
                        )}
                    </div>
                </div>
                <div className={`HRPill HRPill${pillType}`} id="IncidentDateUTC">
                    <p className="HRPillTitle">Incident Date:</p>
                    <div className="HRPillDatePickerWrapper">
                        <DatePicker
                            value={incident.IncidentDateUTC || ""}
                            onChange={(val: number) => this.props.appendParams([{ IncidentDateUTC: moment(val.valueOf()).format().split("T")[0] }])} type="input"
                            useCloseCallback
                            disabled={readOnly}
                        />
                    </div>
                </div>
                <div className={`HRPill HRPill${pillType}`} id="IncidentStateId">
                    <p className="HRPillTitle">State:</p>
                    <div className="HRPillDropdownWrapper">
                        <Select
                            //@ts-ignore
                            value={{ label: incident.StateName || "*NA*" }}
                            options={this.props.incidentReference.states.map((s: any) => ({ value: s.id, label: s.text }))}
                            onChange={(item: any) => {
                                this.props.appendParams([{ IncidentStateId: item.value }, { StateName: item.label }])
                            }}
                            isDisabled={readOnly}
                        // menuPlacement="top"
                        // maxMenuHeight={200}
                        />
                    </div>
                </div>
                <div className={`HRPill HRPill${pillType}`} id="ClaimNumber">
                    <p className="HRPillTitle">Claim #:</p>
                    <div className="HRPillFormControlWrapper">
                        <FormControl onFocus={() => this.props.setEventType("ClaimNumber")}
                            placeholder={incident.ClaimNumber || "Claim Number"}
                            aria-describedby="basic-addon1"
                            onChange={this.props.handleChange}
                            value={incident.ClaimNumber || ""}
                            disabled={readOnly}
                        />
                    </div>
                </div>
                <div className={`HRPill HRPill${pillType}`} id="IncidentStatusId">
                    <p className="HRPillTitle">Status:</p>
                    <div className="HRPillDropdownWrapper">
                        <Select
                            //@ts-ignore
                            value={{ label: incident.IncidentStatusDesc || "*NA*" }}
                            options={this.props.incidentReference.incidentStatus.map((s) => ({ value: s.id, label: s.text }))}
                            onChange={(item: any) => {
                                this.props.appendParams([{ IncidentStatusId: item.value }, { IncidentStatusDesc: item.label }])
                            }}
                            isDisabled={readOnly}
                        />
                    </div>
                </div>
                <div className={`HRPill HRPill${pillType}`} id="FullDutyReleaseDateUTC">
                    <p className="HRPillTitle">Full Duty Release:</p>
                    <div className="HRPillDatePickerWrapper">
                        <DatePicker
                            value={incident.FullDutyReleaseDateUTC || ""}
                            onChange={(val: number) => this.props.appendParams([{ FullDutyReleaseDateUTC: moment(val.valueOf()).format().split("T")[0] }])}
                            type="input"
                            useCloseCallback
                            disabled={readOnly}
                        />
                    </div>
                </div>
                <div className={`HRPill HRPill${pillType}`} id="DaysOffWork">
                    <p className="HRPillTitle">Off Duty (Days):</p>
                    <div className="IncidentInputSpinner">
                        <div className="IncidentInputSpinnerLeft">
                            <span className="material-icons" onClick={() => this.handleNumberSpinner("-", "DaysOffWork")}>remove</span>
                        </div>
                        <div className="IncidentInputSpinnerMiddle">
                            <FormControl onFocus={() => this.props.setEventType("DaysOffWork")}
                                type="number"
                                //@ts-ignore
                                placeholder={incident.DaysOffWork || "0"}
                                aria-describedby="basic-addon1"
                                onChange={this.props.handleChange}
                                value={incident.DaysOffWork || ""}
                                disabled={readOnly}
                            />
                        </div>
                        <div className="IncidentInputSpinnerRight">
                            <span className="material-icons" onClick={() => this.handleNumberSpinner("+", "DaysOffWork")}>add</span>
                        </div>
                    </div>
                </div>
                <div className={`HRPill HRPill${pillType}`} id="DaysLightDuty">
                    <p className="HRPillTitle">Light Duty:</p>
                    <div className="IncidentInputSpinner">
                        <div className="IncidentInputSpinnerLeft">
                            <span className="material-icons" onClick={() => this.handleNumberSpinner("-", "DaysLightDuty")}>remove</span>
                        </div>
                        <div className="IncidentInputSpinnerMiddle">
                            <FormControl onFocus={() => this.props.setEventType("DaysLightDuty")}
                                type="number"
                                //@ts-ignore
                                placeholder={incident.DaysLightDuty || "0"}
                                aria-describedby="basic-addon1"
                                onChange={this.props.handleChange}
                                value={incident.DaysLightDuty || ""}
                                disabled={readOnly}
                            />
                        </div>
                        <div className="IncidentInputSpinnerRight">
                            <span className="material-icons" onClick={() => this.handleNumberSpinner("+", "DaysLightDuty")}>add</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default BasicIncident